<template lang="pug">
  .input-array
    b-form-datalist(
      v-if="autocomplete"
      :id="`auto-list-${ _uid }`",
      :options="calcAutoCompleteItems"
    )
    template(v-for="(item, index) in items")
      .d-flex.flex-row.mb-2(:key="`${ _uid }_${ index }`")
        .flex-fill.mr-2
          b-form-input(
            v-if="autocomplete"
            :list="`auto-list-${ _uid }`"
            v-model="item.value"
            @blur="blurItem(index, $event)"
            @keydown.self="updateFilter"
            @focus="updateFilter"
          )
          b-form-input(
            v-if="!autocomplete"
            :name="name"
            type="text"
            v-model="item.value"
            :disabled="readonly"
            @change="emitInput"
          )
        .level.mr-2(v-if="levels")
          b-form-select(
            :name="name"
            v-model="item.level"
            value-field="value"
            text-field="text"
            :options="levels"
            @change="emitInput"
            :disabled="readonly"
          )
        button.btn.btn-light.btn-one-icon(type="button", @click="remove(item)" v-if="!readonly"): i.ion-close

    .row.mt-2(v-if="!hasSaveButton")
      .col
        button.btn.btn-light.btn-small(type="button", @click="add" v-if="!readonly && items.length < max") Add another
      .col.text-right
        small {{ items.length }}/{{max}}
    template(v-else)
      .row.mt-2
        .col.text-right
          small {{ items.length }}/{{max}}
      .row.mt-2
        .col
          button.btn.btn-light.btn-small(type="button", @click="add" v-if="!readonly && items.length < max") Add another
        .col.text-right
          button.btn.btn-light.btn-small(type="button", @click="$emit('save')" v-if="!readonly && items.length <= max") Save
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import escapeStringRegexp from 'escape-string-regexp'

export default {
  name: 'input-array',
  data: () => ({
    ready: false,
    filter: '',
    items: [],
    oldItems: [],
    currentItem: ''
  }),
  props: {
    id: {
      type: String
    },
    value: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      required: false
    },
    min: {
      type: Number
    },
    max: {
      type: Number,
      default: 10
    },
    readonly: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: Boolean,
      default: false
    },
    autocompleteItems: {
      type: Array
    },
    filterStart: {
      type: Boolean,
      default: false
    },
    levels: {
      type: Array
    },
    hasSaveButton: {
      type: Boolean
    },
    minChars: {
      type: Number,
      default: 0
    }
  },
  methods: {
    updateFilter(event) {
      if (event instanceof KeyboardEvent || event instanceof FocusEvent) {
        this.filter = event.target.value
      }
    },
    add(amount = 1) {
      const items = new Array(amount).fill({}).map((item) => {
        this.$set(item, 'value', '')

        if (this.level) {
          this.$set(item, 'level', '')
        }

        return item
      })

      this.items.push(...items)
      this.oldItems.push(...cloneDeep(items))
      this.emitInput()

      return true
    },
    remove(item) {
      const index = this.items.indexOf(item)

      if (index < 0) {
        return
      }
      this.items.splice(index, 1)
      this.emitInput()
    },
    emitInput() {
      if (this.levels) {
        this.$emit(
          'input',
          this.items.map((i) => ({ ...i }))
        )
      } else {
        this.$emit(
          'input',
          this.items.map((i) => i.value)
        )
      }
    },
    emitItemChanged(index) {
      const newValue = this.items[index]
      const oldValue = this.oldItems[index]

      this.oldItems[index] = cloneDeep(this.items[index])
      this.$emit('item-changed', newValue, oldValue)
    },
    blurItem(index) {
      this.emitInput()
      this.emitItemChanged(index)
    },
    changeLevel(index, event) {
      this.items[index].level = event
      this.emitItemChanged(index)
      this.emitInput()
    }
  },
  computed: {
    calcAutoCompleteItems() {
      const startRegexp = this.filterStart ? '^' : ''
      const searchRegexp = new RegExp(`${startRegexp}${escapeStringRegexp(this.filter)}`, 'i')

      if (!this.filter.length && this.filterStart) {
        return []
      }

      if (this.minChars > this.filter.length + 1) {
        return []
      }

      return this.autocompleteItems.filter((i) => searchRegexp.test(i)).map((i) => i)
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        this.ready = false
        this.items = value.map((v) => {
          const item = {}

          if (typeof v !== 'object') {
            this.$set(item, 'value', v)
          } else {
            this.$set(item, 'value', v.value)

            if (this.levels) {
              this.$set(item, 'level', v.level)
            }
          }

          return item
        })
        this.oldItems = cloneDeep(this.items)
        this.$nextTick(() => {
          this.ready = true
        })
      }
    }
  },
  beforeMount() {
    if (!this.value || this.value.length === 0) {
      this.add(this.min || 1)
    }
    this.ready = true
  }
}
</script>
